export const getSubtypeFromTemplateType = (templateType: string) => {
	const subtypeLabels = {
		DO: "Dommages Ouvrage",
		TRC: "Tous Risques Chantier",
		MRT: "Multi Risques Travaux",
		GFA: "Garantie Financière Achèvement",
	};

	const match = templateType.match(/_(DO|TRC|MRT|GFA)$/);
	if (match) {
		const typeKey = match[1] as keyof typeof subtypeLabels;
		return subtypeLabels[typeKey] || typeKey;
	}
	return null;
};

export const getTemplateBaseType = (templateType: string) => {
	if (templateType.startsWith("PROPOSITION_ASSURANCE_")) {
		return "Proposition d'assurance";
	}
	if (templateType.startsWith("CONDITIONS_GENERALES_")) {
		return "Conditions générales";
	}

	const baseType = templateType.replace(/_(DO|TRC|MRT|GFA)$/, "");

	return baseType
		.toLowerCase()
		.replace(/_/g, " ")
		.replace(/\b\w/g, (letter) => letter.toUpperCase());
};

export const formatTemplateTypeForDisplay = (templateType: string) => {
	return getTemplateBaseType(templateType);
};
